import React, { Component } from 'react';
import { Modal, Form, Input } from 'antd';

class ModalInvalid extends Component {
  onOk = () => {
    this.props.form.validateFields((err, value) => {
      if (!err) {
        this.props.onOk(value, this.props.data);
      }
    });
  };

  render() {
    const { getFieldDecorator } = this.props.form;

    return (
      <Modal
        title="发票作废"
        visible={this.props.visible}
        onOk={this.onOk}
        onCancel={this.props.onCancel}
      >
        <Form>
          <Form.Item label="作废原因">
            {getFieldDecorator('reason', {
              rules: [{ required: true, message: '请填写作废原因' }],
            })(<Input />)}
          </Form.Item>
        </Form>
      </Modal>
    );
  }
}
export default Form.create()(ModalInvalid);



// WEBPACK FOOTER //
// ./src/components/finance/invoice/ModalInvalid.js